import { Box, Button, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import { FilterIcon,
 SortIcon,
  PlusIcon,
  ChevronDownIcon,
  InprogressIcon,
  CompletedIcon,
  TaskIcon,
  TotalEventIcon,
} from '~/assets/icons';
import { BaseCard } from '~/components/common';
import { useTranslation } from 'react-i18next';
import ProjectList from './components/ProjectList';
import { StatusMode } from '~/utils/types/job';
import { useAppDispatch, useAppSelector } from '~/redux/hooks';
import { jobActions } from '~/thunks/job/jobSlice';
import useDebounce from '~/hooks/useDebounce';

type StatusModeState = StatusMode | 'all';
type ViewModeState = 'list' | 'board';

type JobAmountsProps = {
  amount: number;
  isSelected: boolean;
};

const JobAmounts = (props: JobAmountsProps) => {
  const { amount, isSelected } = props;
  return (
    <Box
      className={cx(
        isSelected
          ? 'ml-[4px] px-[4px] py-[2px] rounded-[3px] bg-[#F7FAFE] text-[#565F69] text-[10px]/[12px]'
          : 'ml-[4px] px-[4px] py-[2px] rounded-[3px] bg-[#FFF] text-[#565F69] text-[10px]/[12px]'
      )}
    >
      {amount}
    </Box>
  );
};

const Project = () => {
  const [viewMode, setViewMode] = useState<ViewModeState>('list');
  const [selectedIds, setSelectedIds] = useState<Array<string>>([]);
  const [searchInput, setSearchInput] = useState<string>('');

  const searchInputDebounce = useDebounce<string>(searchInput);

  const statusMode = useAppSelector((state) => state.job.statusMode);
  const countsJobPerStatusMode = useAppSelector((state) => state.job.countsJobPerStatusMode);

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(jobActions.changeSearchInput(searchInputDebounce));
  }, [searchInputDebounce, dispatch]);

  const handleChangeFilterMode = (event: React.ChangeEvent<{}>, newValue: StatusModeState) => {
    dispatch(jobActions.changeStatusMode(newValue));
  };

  const handleChangeViewMode = (event: React.ChangeEvent<{}>, newValue: ViewModeState) => {
    setViewMode(newValue);
  };

  const { t } = useTranslation(['admin/project']);

  return (
    <Box className='w-full h-full'>
      <Box className="flex items-center flex-1 justify-between">
        <Typography className="text-[32px]/[38.4px] font-normal">{t('title')}</Typography>
        <Button
          className='h-[36px] px-[14px] py-[9.5px] text-sm/[16.8px] bg-[#0A1435] font-medium rounded-[8px] ml-[10px]'
          variant='contained'
          disableElevation
          startIcon={<PlusIcon className='w-[10px] h-[10px]' />}
        >
          {t('addJob')}
        </Button>
      </Box>
      <Box className="mt-[20px] flex items-center flex-1 justify-between">
        <Box className='flex flex-col min-[1080px]:flex-1 min-[1080px]:justify-between'>
          <Box className='flex items-center justify-between'>
            {/*<BaseTabList
              value={statusMode}
              onChange={handleChangeFilterMode}
              TabIndicatorProps={{ style: { backgroundColor: 'transparent' } }}
            >
              {STATUS_TABS.map((status: string, index: number) => (
                <BaseTab
                  key={status}
                  value={status}
                  label={t(`${status}`)}
                  icon={<JobAmounts amount={countsJobPerStatusMode[status]} isSelected={statusMode === status} />}
                  iconPosition='end'
                />
              ))}
            </BaseTabList>*/}
            <BaseCard
              icon={<InprogressIcon className='mb-[10px] w-[37px] h-[37px]'/>}
              status='In progress'
              total={5.36}
              percent={50.45}
            ></BaseCard>
            <BaseCard
              icon={<CompletedIcon className='mb-[10px] w-[37px] h-[37px]'/>}
              status='Completed'
              total={4.79}
              percent={50.45}
            ></BaseCard>
            <BaseCard
              icon={<TaskIcon className='mb-[10px] w-[37px] h-[37px]'/>}
              status='Task'
              total={6.21}
              percent={50.45}
            ></BaseCard>
            <BaseCard
              icon={<TotalEventIcon className='mb-[10px] w-[37px] h-[37px]'/>}
              status='Total Event'
              total={4.79}
              percent={50.45}
            ></BaseCard>
          </Box>

          {/*<Box className='flex flex-row mt-[10px] min-[1080px]:mt-0'>
            <Button
              className={cx(
                'h-[36px] px-[14px] py-[9.5px] text-sm/[16.8px] font-medium rounded-[8px] mr-[10px] bg-[#D52B1E] hover:bg-[#d52b1ecc]',
                { 'visibility: visible': selectedIds.length > 0 },
                { 'visibility: hidden': selectedIds.length <= 0 }
              )}
              variant='contained'
              disableElevation
              startIcon={<TrashIcon className='w-[17px] h-[17px]' stroke='white' />}
            >
              {t('delete')}
            </Button>

            <BaseInput
              className='w-[204px]'
              value={searchInput}
              onChange={(e) => {
                setSearchInput(e.target.value);
              }}
              placeholder={t('searchPlaceholder')}
              iconStart={
                <Box>
                  <SearchIcon className='w-[16px]' />
                </Box>
              }
            />
          </Box>*/}
        </Box>
      </Box>
      <Box className='mt-[20px] flex flex-col min-[1080px]:flex-row item-center justify-between'>
        <Typography className="text-[26px]/[38.4px] font-normal">{t('all_project')}</Typography>
        <Box className='flex flex-row mt-[10px] min-[1080px]:flex-row min-[1080px]:ml-[10px] min-[1080px]:mt-0'>
          <Button
            variant='outlined'
            className='bg-[#F4F4F6] text-[#797D8A] border border-[#E5EAEF] hover:border-[#E5EAEF] rounded-[8px] text-[14px]/[16.8px] font-medium mr-[10px] h-[36px] px-[9px] py-[9.5px]'
            startIcon={<SortIcon className='w-[13px] h-[13px]' />} endIcon={<ChevronDownIcon className='w-[17px] h-[17px]' />}
          >
            {t('sortBy')}
          </Button>

          <Button
            variant='outlined'
            className='bg-[#F4F4F6] text-[#797D8A] border border-[#E5EAEF] hover:border-[#E5EAEF] rounded-[8px] text-[14px]/[16.8px] font-medium h-[36px] px-[9px] py-[9.5px]'
            startIcon={<FilterIcon className='w-[13px] h-[13px]' />} endIcon={<ChevronDownIcon className='w-[17px] h-[17px]' />}
          >
            {t('filter')}
          </Button>
        </Box>

{/*        <Box className='flex flex-row mt-[10px] min-[1080px]:flex-row min-[1080px]:ml-[10px] min-[1080px]:mt-0 justify-between'>
          <BaseTabList
            value={viewMode}
            onChange={handleChangeViewMode}
            TabIndicatorProps={{ style: { backgroundColor: 'transparent' } }}
          >
            <BaseTab
              key='list'
              value={'list'}
              label={t('list')}
              iconPosition='start'
              icon={
                viewMode === 'list' ? (
                  <ViewListIcon className='w-[17px] h-[17px]' stroke='#054DFF' />
                ) : (
                  <ViewListIcon className='w-[17px] h-[17px]' />
                )
              }
            />
            <BaseTab
              key='board'
              value={'board'}
              label={t('board')}
              iconPosition='start'
              icon={
                viewMode === 'board' ? (
                  <ViewBoardIcon className='w-[17px] h-[17px]' stroke='#054DFF' />
                ) : (
                  <ViewBoardIcon className='w-[17px] h-[17px]' />
                )
              }
            />
          </BaseTabList>
        </Box>*/}
      </Box>

      <Box className='mt-[40px]'>
        <ProjectList setSelectedIds={setSelectedIds} />
      </Box>
    </Box>
  );
};

export default Project;
